import { createContext, useContext } from 'react'

export interface ConfirmDialogOptions {
  title: string
  description: string
  confirmText?: string
  cancelText?: string
  variant?: 'default' | 'destructive'
  /**
   * When set, the confirm button is disabled until the user types `match` exactly.
   * Use for destructive actions like deletion where the entity name must be typed.
   */
  requireInput?: { match: string }
  onConfirm: () => void | Promise<void>
  onCancel?: () => void
}

interface ConfirmDialogContextType {
  showConfirmDialog: (options: ConfirmDialogOptions) => void
}

export const ConfirmDialogContext = createContext<
  ConfirmDialogContextType | undefined
>(undefined)

export function useConfirmDialog() {
  const context = useContext(ConfirmDialogContext)
  if (!context) {
    throw new Error(
      'useConfirmDialog must be used within a ConfirmDialogProvider',
    )
  }
  return context
}
